import { dropdownTriggerClassname } from "app/components/Dropdown";
import { StatusIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import CommonStatusSelection from "app/containers/Features/components/CommonStatusSelection";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getStatusById } from "../../../../helpers";
import { ITickets } from "../../types";

interface Props {
  ticket: ITickets;
  onUpdate: (id: string) => void;
}

const Status: React.FC<Props> = ({ ticket, onUpdate }) => {
  const { status } = ticket;
  const statusData = useSelector(selectTicketStatus);

  const handleSelect = (data: ITicketStatus) => {
    onUpdate(data._id);
  };

  // // FIX: selectedStatus now works
  const selectedStatus = useMemo(() => {
    return getStatusById(statusData, status);
  }, [statusData, status]);

  return (
    <div className=" relative w-full ">
      <CommonStatusSelection
        trigger={
          <button className={clsx("flex items-center justify-between w-full p-[6px]  ",dropdownTriggerClassname)}>
            <CustomTooltip
              text="Set status"
              className="flex items-center w-full gap-1"
              position="left"
            >
              <div className="flex gap-1">
                <StatusIcon size={16} color={selectedStatus?.color} />
                <span
                  className={`text-secondary text-normal text-xs uppercase  `}
                >
                  {selectedStatus?.name}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
        isHeader="statuses"
        value={status}
        setValue={handleSelect}
      />
    </div>
  );
};

export default Status;
